import moment from "moment";

export default function TestDueHooks() {
  const currentDueLabel = (date) => {
    const dueDate = new Date(date);

    let serverDate = localStorage.getItem("date");

    if (serverDate == undefined) {
      serverDate = new Date();
    } else {
      serverDate = new Date(serverDate);
    }

    const currentDate = serverDate;
    const timeDifference = dueDate.getTime() - currentDate.getTime();
    const dayDifference = Math.floor(timeDifference / (1000 * 3600 * 24));

    if (dayDifference === 0) {
      return "Due Today";
    } else if (
      dayDifference === 1 ||
      (dayDifference === 0 && dueDate !== currentDate)
    ) {
      return "Due Tomorrow";
    } else if (dayDifference < 0) {
      return "Past Due";
    } else {
      return "Upcoming";
    }
  };

  const getDayDifference = (endDate = moment(), startdate = moment()) => {
    return moment(endDate)
      .startOf("day")
      .diff(moment(startdate).startOf("day"), "days");
  };

  return { currentDueLabel, getDayDifference };
}
